import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { isIpAllowed } from '../utils/ipUtils';

const IpRestrictionGuard = () => {
  const [ipAllowed, setIpAllowed] = useState(true);
  const [ipChecking, setIpChecking] = useState(true);
  const [userIp, setUserIp] = useState('');

  useEffect(() => {
    const checkIpRestriction = async () => {
      const allowedIpsConfig = process.env.REACT_APP_ALLOWED_SITE_IPS || process.env.REACT_APP_ALLOWED_DEV_IPS;

      // If env var is empty, null, or '*', bypass restriction check
      if (!allowedIpsConfig || allowedIpsConfig.trim() === '' || allowedIpsConfig.trim() === '*') {
        setIpAllowed(true);
        setIpChecking(false);
        return;
      }

      try {
        let fetchedIp = '';
        try {
          const res = await fetch('https://api4.ipify.org?format=json');
          if (res.ok) {
            const data = await res.json();
            fetchedIp = data.ip;
          }
        } catch (err) {
          // Fallback to api.ipify.org
          const res = await fetch('https://api.ipify.org?format=json');
          if (res.ok) {
            const data = await res.json();
            fetchedIp = data.ip;
          }
        }

        if (!fetchedIp) {
          setIpAllowed(false);
          setIpChecking(false);
          return;
        }

        setUserIp(fetchedIp);
        const allowed = isIpAllowed(fetchedIp, allowedIpsConfig);
        setIpAllowed(allowed);
      } catch (err) {
        console.error('IP address verification error:', err);
        setIpAllowed(false);
      } finally {
        setIpChecking(false);
      }
    };

    checkIpRestriction();
  }, []);

  if (ipChecking) {
    return null;
  }

  if (!ipAllowed) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
            <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h2 className="text-xl font-bold text-gray-800 mb-2">アクセスが拒否されました</h2>
          <p className="text-sm text-gray-600 mb-4">
            このIPアドレスからのアクセスは許可されていません。
          </p>
          {userIp && (
            <p className="text-xs text-gray-500 bg-gray-50 p-2 rounded border border-gray-200 font-mono">
              IP Address: {userIp}
            </p>
          )}
        </div>
      </div>
    );
  }

  return <Outlet />;
};

export default IpRestrictionGuard;
